module.exports = __webpack_public_path__ + "img/SEED_tile.e763b7a7.png";